import {useGetUsersByPatient} from '@/features/users/queries/useGetUsersByPatient'
import {useInputSearch} from '@/hooks/useInputSearch'
import {useMemo} from 'react'

export const useUsersByPatientSearchableList = ({
    patientId,
    enabled,
    limit = 10
}: {
    patientId: string
    enabled?: boolean
    limit?: number
}) => {
    const searchControls = useInputSearch()
    const query = useGetUsersByPatient(
        {
            patientId,
            search: searchControls.searchValue,
            limit,
            page: 1
        },
        {enabled}
    )

    const users = useMemo(() => query.data?.pages.flatMap(page => page.data) ?? [], [query.data])

    return {
        ...query,
        ...searchControls,
        users
    }
}
